<template>
	<div class="presidencia">
		<v-container  
				class="overflow-y-auto"
		>
			<v-layout row>
				<v-flex md9 xs12 class="mt-3">
					<h1 class="pb-0 mb-0">PRESIDENTE</h1>
					<v-card
						class="mx-auto mt-0"
						max-width="700"
					>
						<v-img
						height="750"
						src="image/presidentecsjp2025-2026.jpg"
						></v-img>

						<v-card-title class="pb-0">DR. BENNY JOSE ALVAREZ QUIÑONEZ</v-card-title>
						<v-card-text>
							<div class="mt-0 subtitle-1">
								PRESIDENTE DE LA CORTE SUPERIOR DE JUSTICIA DE PUNO (2025-2026)
							</div>

							<div>
								<p>
									El Presidente de la Corte Superior de Justicia de Puno representa al Poder Judicial en el Distrito Judicial Puno.
								</p>
								<p>
									Es elegido el primer jueves del mes de diciembre, cada dos años y en votación secreta por los Jueces Superiores Titulares de la respectiva Corte, los cuales se reúnen en sesión de Sala Plena.
								</p>
								<p>
									La Presidencia de la Corte Superior de Justicia de Puno, es presidida por el Dr. Benny Jose Alvarez Quiñonez; para el periodo 2025 - 2026
								</p>
							</div>
						</v-card-text>

						<v-divider class="mx-4"></v-divider>
						<v-card-text>

						<v-btn href="https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_corte_superior_puno/as_presidencia/as_documentos/" target="_blank" color="red darken-4" dark>
							<v-icon>mdi-file-multiple</v-icon> &nbsp;

							&nbsp;&nbsp; Documentos de Presidencia
						</v-btn>
						<!--<v-btn href="https://www.pj.gob.pe/wps/wcm/connect/392a8100430a4c8ca15ca11c629fb1f0/PLAN+DE+GESTI%C3%93N+CSJ+PUNO+2021-2022.pdf?MOD=AJPERES&CACHEID=392a8100430a4c8ca15ca11c629fb1f0" target="_blank" color="red darken-4" dark>
							<v-icon>mdi-file-multiple</v-icon> &nbsp;

							&nbsp;&nbsp; Plan de Gestión 
						</v-btn>
						-->
					</v-card-text>
					</v-card>
					<v-card-title>Son funciones y atribuciones del Presidente de la Corte Superior:</v-card-title>

					<v-card-text>
						<v-list>
							<v-list-item v-for="funcion in funciones" v-bind:key="funcion.id">
								<v-list-item-content>
									<span>
										{{funcion.id}}.-{{funcion.text}}
									</span>	
								</v-list-item-content>
							</v-list-item>
						</v-list>
						
					</v-card-text>
					
					
				</v-flex>
				<v-flex md3 xs12>
					<Servicios />

				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
  const Servicios = () => import('@/components/Servicios.vue')

export default {
	components: {
        Servicios
    },
	data(){
        return {
			funciones:[
				{id:'1', text:'Representar al Poder Judicial, en su respectivo Distrito Judicial;'},
				{id:'2', text:'Convocar, presidir y dirigir las Salas Plenas y las sesiones del Consejo Ejecutivo Distrital. En ambos casos tiene voto dirimente;'},
				{id:'3', text:'Dirigir la aplicación de la política del Poder Judicial en su Distrito, en coordinación con el Consejo Ejecutivo del Poder Judicial;'},
				{id:'4', text:'Cautelar la pronta administración de justicia, así como el cumplimiento de las obligaciones de los Magistrados del Distrito Judicial;'},
				{id:'5', text:'Supervisar la asistencia y puntualidad de los Magistrados cautelando que se registre en su legajo personal;'},
				{id:'6', text:'Ejecutar los acuerdos de la Sala Plena y del Consejo Ejecutivo Distrital;'},
				{id:'7', text:'Conformar las Salas de acuerdo al criterio de especialización;'},
				{id:'8', text:'Coordinar y supervigilar el cumplimiento de las labores del Consejo Ejecutivo Distrital.'},
				{id:'9', text:'Dar cumplimiento a las disposiciones legales emitidas por los órganos rectores gubernamentales, disposiciones administrativas de los Órganos de Dirección y Gerencia General del Poder Judicial, así como a la Política de Seguridad de la información del Poder Judicial, en el ámbito de su competencia.'},
				{id:'10', text:'Ser titular de la Unidad Ejecutora – Entidad.'},
				{id:'11', text:'Designar al personal de Dirección y de Confianza en su respectivo Distrito Judicial, bajo los parámetros y procedimientos que señalen las normas sobre la materia, a excepción del Gerente de Administración Distrital. Ejercer las demás que señalan las leyes y la normatividad sobre la materia.'},
			],
		}
	}
}
</script>
